import { useUIStore } from '@/stores/uiStore';
import { useT } from '@/i18n/useI18n';

const APP_STORE_URL = 'https://apps.apple.com/app/id6778849374';
const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=games.dontmiss.app';

/**
 * Shown when a web user tries to enter the gameplay flow (quick match, create /
 * join room). Matches run only in the native apps, so we push users to the
 * stores instead. Mounted once in App; visibility is driven by uiStore.
 */
export function PlayGateModal() {
  const open = useUIStore((s) => s.playGateOpen);
  const close = useUIStore((s) => s.closePlayGate);
  const t = useT();

  if (!open) return null;
  return (
    <div
      className="responsive-modal"
      onClick={close}
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,0.72)',
        backdropFilter: 'blur(6px)',
        zIndex: 600,
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'center',
        padding: 'max(env(safe-area-inset-top, 0px), 18px) 18px max(env(safe-area-inset-bottom, 0px), 18px)',
      }}
    >
      <div
        className="responsive-modal__card"
        onClick={(e) => e.stopPropagation()}
        style={{
          width: '100%',
          maxWidth: 360,
          background: 'rgba(15,18,32,0.98)',
          border: '1px solid var(--hairline)',
          borderRadius: 16,
          padding: 22,
          boxShadow: '0 16px 48px rgba(0,0,0,0.5)',
          animation: 'cd-toast-in 0.25s ease-out',
        }}
      >
        <div
          className="display"
          style={{ fontSize: 18, letterSpacing: '0.05em', color: 'var(--c-cyan)', marginBottom: 8 }}
        >
          {t('playgate.title')}
        </div>
        <div style={{ fontSize: 13, color: 'var(--ink-muted)', lineHeight: 1.45, marginBottom: 18 }}>
          {t('playgate.body')}
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          <a className="btn btn-primary" href={APP_STORE_URL} target="_blank" rel="noopener noreferrer">
            {t('playgate.ios')}
          </a>
          <a className="btn btn-primary" href={PLAY_STORE_URL} target="_blank" rel="noopener noreferrer">
            {t('playgate.android')}
          </a>
          <button
            className="btn"
            onClick={close}
            style={{ background: 'transparent', border: '1px solid var(--hairline)', color: 'var(--ink-muted)' }}
          >
            {t('common.close')}
          </button>
        </div>
      </div>
    </div>
  );
}
